import { Base } from '@studiometa/js-toolkit';

/**
 * @typedef {{}} StickyWidgetProps
 */

/**
 * StickyWidget component.
 * @augments {Base<StickyWidgetProps>}
 */
export default class StickyWidget extends Base {
  /**
   * Class config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'StickyWidget',
    refs: ['close'],
    options: {
      delay: {
        type: Number,
        default: 0,
      },
    },
  };

  /**
   * Get widget visibility
   * @returns {string} Current User Profile from Session Cookies
   */
  get widgetVisibility() {
    return localStorage.getItem('widgetHide');
  }

  /**
   * Set widget visibility
   * @param  {string} value value setted.
   * @returns {void}
   */
  set widgetVisibility(value) {
    localStorage.setItem('widgetHide', value);
  }

  /**
   * Mount component and launch widget
   * @returns {void}
   */
  mounted() {
    if (!this.widgetVisibility) {
      const delay = this.$options.delay * 1000;
      setTimeout(() => {
        this.showWidget();
      }, delay);
    }
  }

  /**
   * Click on close btn and hide widget
   * @returns {void}
   */
  onCloseClick() {
    this.hideWidget();
  }

  /**
   * Show widget
   * @returns {void}
   */
  showWidget() {
    this.$el.classList.remove('translate-x-[110%]');
  }

  /**
   * Hide widget
   * @returns {void}
   */
  hideWidget() {
    this.$el.classList.add('translate-x-[110%]');
    this.widgetVisibility = true;
  }
}
